import React, { useEffect } from "react";
import {
  HomeCarousel,
  HomeContainer,
  HomeECECard,
  HomeRPCard,
  ReferralContestContainer,
} from "./Home.styled";
import { useDispatch, useSelector } from "react-redux";
import {
  getContestants,
  getUserInvites,
} from "../../feature/referral/ReferralActions";
import { inviteErnings } from "../../feature/invite/InviteActions";
import { minerEarnings } from "../../feature/minerEarning/MinerEarningActions";
import { getUserNotifications } from "../../feature/notification/NotificationActions";
import { Link } from "react-router-dom";
import Slideshow from "../SlideShow/SlideShow";
import Avatar, { genConfig } from "react-nice-avatar";
import InstallPrompt from "../../components/InstallPrompt/InstallPrompt";

const Home = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { invites, contestants } = useSelector((state) => state.referral);
  const { earning } = useSelector((state) => state.invite);
  const { minerEarning } = useSelector((state) => state.minerEarning);

  useEffect(() => {
    Object.keys(user).length &&
      dispatch(getUserInvites({ referral_code: user.referral_code }));
    Object.keys(user).length && dispatch(inviteErnings({ user: user.id }));
    Object.keys(user).length && dispatch(minerEarnings({ user: user.id }));
    Object.keys(user).length && dispatch(getUserNotifications({ user: user }));
    Object.keys(user).length && dispatch(getContestants({}));
  }, [dispatch, user]);

  return (
    <HomeContainer>
      <HomeCarousel>
        <Slideshow />
      </HomeCarousel>
      <HomeECECard>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginBlock: "20px",
            fontWeight: "bolder",
            fontSize: "20px",
          }}
        >
          <div style={{ fontWeight: "bolder", marginBlockEnd: "10px" }}>
            Miner Earnings:
          </div>
          <div style={{ fontSize: "15px" }}>
            {minerEarning && minerEarning.amount_earned} TRX
          </div>
        </div>
        <div style={{ borderBottom: "1px solid #7B36EE" }}></div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "20px 30px",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <div style={{ marginBlockEnd: "10px" }}>Total Invites</div>
            <div style={{ fontSize: "small" }}>{invites.length}</div>
          </div>
          <div style={{ borderRight: "1px solid #7B36EE" }}></div>
          <div style={{ textAlign: "center" }}>
            <div style={{ marginBlockEnd: "10px" }}>Invite Earnings</div>
            <div style={{ fontSize: "small" }}>
              {earning && earning.amount_earned} TRX
            </div>
          </div>
        </div>
      </HomeECECard>
      <InstallPrompt />
      <ReferralContestContainer>
        <Link
          to="/referral-contest"
          style={{
            border: "1px solid #7B36EE",
            color: "#7B36EE",
            height: "35px",
            marginBlock: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          REFERRAL CONTEST
        </Link>
        <div
          style={{
            // background: "#592498",
            border: "1px solid rgba(223, 232, 115, 0.2)",
            padding: "20px",
            marginBlock: "40px 30px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              backgroundColor: "#7B36EE",
              color: "#fff",
              fontWeight: "bolder",
              fontSize: "20px",
              height: "30px",
              width: "60%",
              marginBlock: "-40px 10px",
              marginInline: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Leaderboard
          </div>
          {contestants.slice(0, 3).map((data, index) => (
            <div
              style={{
                // background: "#592498",
                border: "1px solid #7B36EE",
                padding: "10px",
                display: "flex",
                alignItems: "center",
                marginBlockEnd: "10px",
              }}
              key={index}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    backgroundColor: "#7B36EE",
                    color: "#fff",
                    fontWeight: "bolder",
                    fontSize: "18px",
                    padding: "8px",
                  }}
                >
                  {index + 1}
                </div>
                <div>
                  <Avatar
                    style={{
                      height: 30,
                      width: 30,
                      objectFit: "cover",
                      borderRadius: "50%",
                      marginInline: "15px",
                    }}
                    isGradient={true}
                    {...genConfig(`${data.user_set.username}`)}
                  />
                </div>
                <div>{data.user_set.username}</div>
              </div>
              <div style={{ marginInlineStart: "auto" }}>
                {data.referral_count}
              </div>
            </div>
          ))}
          <Link
            to="/pubmining-referral-contest-tc"
            style={{ marginInline: "auto" }}
          >
            PubMining Referral Contest Terms&Condition
          </Link>
        </div>
      </ReferralContestContainer>
      <HomeRPCard>
        <h3 style={{ lineHeight: "0px" }}>Reward Program</h3>
        <p>
          Make extra TRX by inviting friends. You get rewarded when they buy
          their first Miner. <Link to="/reward">Click to learn more</Link>{" "}
        </p>
      </HomeRPCard>
      {/* <TawkMessengerReact propertyId="645436d06a9aad4bc578f976" widgetId="1gvkfc8hj" /> */}
    </HomeContainer>
  );
};

export default Home;
